module.exports = __webpack_public_path__ + "static/media/105.8c7b9200.jpg";